import { getProccessingTransactions } from 'APIs/transactionApi';
import { useAppSelector } from 'app/hooks';
import TransactionTable from 'components/molecules/TransactionTable';
import TransactionStats from 'components/molecules/TransactionTable/TransactionStats';
import { selectAuth } from 'features/auth/authSlice';
import { Transaction } from 'interfaces/Transaction.interface';
import React from 'react';

const TransactionsBody = () => {
  const [transactions, setTransactions] = React.useState<Transaction[]>([]);
  const authState = useAppSelector(selectAuth);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setLoading(true);
    const getTransactions = async () => {
      const getUserTransactions = await getProccessingTransactions('all');
      setTransactions(getUserTransactions.data);
      setLoading(false);
    };
    getTransactions();
  }, [authState.id]);

  const getTotalEarnings = (type: 'all' | 'weekly' | 'monthly') => {
    let total = 0;
    transactions.forEach(trx => (total += parseFloat(trx.amount)));
    return (
      type === 'all' ? total : type === 'weekly' ? total / 52 : total / 12
    ).toFixed(6);
  };

  return (
    <div className="transaction-container">
      <h1>Transactions</h1>
      <div className="stats-container-large">
        <TransactionStats
          heading="Total Earnings"
          value={getTotalEarnings('all')}
        />
        <TransactionStats
          heading="Earnings Per Week"
          value={getTotalEarnings('weekly')}
        />
        <TransactionStats
          heading="Earnings Per Month"
          value={getTotalEarnings('monthly')}
        />
      </div>
      <div>
        <h2>All Transactions</h2>
        <TransactionTable transactions={transactions} loading={loading} />
      </div>
    </div>
  );
};

export default TransactionsBody;
